import * as Types from './Types';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'src/reducers/RootReducer';
import { ActionCreator, Dispatch } from 'react-redux';
import ApiClient from 'src/services/api-client/ApiClient';
import { AxiosResponse } from 'axios';
import ValidatorService from 'src/services/validation/Validation.service';
import Person from 'src/entities/Person';
import Resource from 'src/services/api-client/resource/base/Resource';
import ProfileMetrics from 'src/value-objects/ProfileMetrics';

export interface GetProfileMetricsAttempt extends Action {
  type: Types.GET_PROFILE_METRICS_ATTEMPT;
}

export interface GetProfileMetricsSuccess extends Action {
  type: Types.GET_PROFILE_METRICS_SUCCESS;
  payload: ProfileMetrics;
}

export interface GetProfileMetricsFailure extends Action {
  type: Types.GET_PROFILE_METRICS_FAILURE;
  payload: {};
}

export type GetProfileMetricsAction =
  GetProfileMetricsAttempt | GetProfileMetricsSuccess | GetProfileMetricsFailure;

export interface GetProfileMetricsThunk extends ThunkAction<Promise<GetProfileMetricsAction>, RootState, null> {
}

export const getProfileMetricsAttempt: ActionCreator<GetProfileMetricsAttempt> = () => (
  {
    type: Types.GET_PROFILE_METRICS_ATTEMPT,
  }
);

export const getProfileMetricsSuccess: ActionCreator<GetProfileMetricsSuccess> = (metrics: ProfileMetrics) => (
  {
    type: Types.GET_PROFILE_METRICS_SUCCESS,
    payload: metrics,
  }
);

export const getProfileMetricsFailure: ActionCreator<GetProfileMetricsFailure> = (error: {}) => (
  {
    type: Types.GET_PROFILE_METRICS_FAILURE,
    payload: error
  }
);

export const getProfileMetrics: ActionCreator<GetProfileMetricsThunk> = (
  profile: Person,
): GetProfileMetricsThunk => {
  return (dispatch: Dispatch<RootState>): Promise<GetProfileMetricsAction> => {
    dispatch(getProfileMetricsAttempt());

    let call: Resource;
    if (profile.personType === 'juridical') {
      call = ApiClient.juridicalPersonMetrics;
    } else {
      call = ApiClient.physicalPersonMetrics;
    }
    return call.get(profile.id)
      .then((response: AxiosResponse): GetProfileMetricsSuccess => {
        return dispatch(getProfileMetricsSuccess(response.data));
      }).catch((e: { response: { data: { errors: {} } } }): GetProfileMetricsFailure => {
        const errors = ValidatorService
          .translateValidations(e && e.response && e.response.data && e.response.data.errors);

        return dispatch(getProfileMetricsFailure(errors));
      });
  };
};


// WEBPACK FOOTER //
// ./src/actions/profile-metrics/get/GetProfileMetrics.actions.tsx